import React from 'react';
import SEO from '../components/SEO';
import './Reposeidas.css';

const Reposeidas = () => {
  const reposeidaWebsites = [
    {
      id: 1,
      name: 'HUD Homes',
      url: 'https://www.hudhomestore.gov/searchresult?citystate=PR',
      description: 'Propiedades del Departamento de Vivienda y Desarrollo Urbano de EE.UU.',
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fhudhomestore.png?alt=media&token=45041f4d-68f7-4631-acd1-bb07c5bcd5c6'
    },
    {
      id: 2,
      name: 'Banco Popular',
      url: 'https://deshow.com/agentes/alicearealty/?operation=En+venta',
      description: 'Propiedades reposeídas del Banco Popular de Puerto Rico',
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fbancopopular.png?alt=media&token=794e2f40-fbdc-4906-a990-91a62142701e'
    },
    {
      id: 3,
      name: 'FirstBank',
      url: 'https://1firstbank.res.net/',
      description: 'Propiedades reposeídas de FirstBank Puerto Rico',
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Ffirstbank.png?alt=media&token=6ab961de-c1a2-4cb6-aa80-ead861ad7753'
    },
    {
      id: 4,
      name: 'Oriental Bank',
      url: 'http://orientalpcs.azurewebsites.net/',
      description: 'Propiedades reposeídas del Banco Oriental',
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Foriental.png?alt=media&token=2fdcb8fd-4c64-428c-8d5c-d952f5a97ff7'
    }
  ];

  return (
    <div className="reposeidas">
      <SEO 
        title="Propiedades Reposeídas en Puerto Rico | Alicea Realty Group LLC | Noemi Alicea"
        description="Encuentra propiedades reposeídas en Puerto Rico a través de las principales instituciones financieras. Enlaces a HUD Homes, Banco Popular, FirstBank, y Oriental Bank. Noemí Alicea González, Corredora Autorizada de HUD."
        keywords="propiedades reposeídas Puerto Rico, casas reposeídas, HUD homes Puerto Rico, banco popular reposeidas, firstbank reposeidas, oriental bank reposeidas, Alicea Realty Group, Noemi Alicea, HUD broker Puerto Rico"
        ogTitle="Propiedades Reposeídas en Puerto Rico"
        ogDescription="Enlaces a las principales fuentes de propiedades reposeídas en Puerto Rico"
        ogImage="https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Farg_logo_nobg.png?alt=media&token=53b347a3-8d9e-4e5a-8a1f-64b7cbc32e69"
        canonical="https://www.alicearealtypr.com/reposeidas"
      />

      <section className="reposeidas-content">
        <div className="container">
          <div className="reposeidas-intro">
            <h2>Enlaces a Sitios de Propiedades Reposeídas</h2>
            <p><b>
              A continuación, encontrará enlaces a las principales instituciones que ofrecen propiedades reposeídas en Puerto Rico. 
            </b>
            </p>
          </div>

          <div className="reposeidas-grid">
            {reposeidaWebsites.map((site) => (
              <div key={site.id} className="reposeida-card">
                <div className="reposeida-image">
                  <img src={site.image} alt={site.name} />
                </div>
                <div className="reposeida-info">
                  <h3>{site.name}</h3>
                  <p>{site.description}</p>
                  <a 
                    href={site.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="reposeida-link"
                  >
                    Visitar Sitio Web
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="reposeidas-disclaimer">
            <h3>Información Importante</h3>
            <p>
              En Alicea Realty Group LLC, estamos disponibles para asistirle en la compra de propiedades reposeídas y responder cualquier pregunta que pueda tener al <a href="tel:+17873421648">787-342-1648</a>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Reposeidas;
